import React from 'react';
import ReactLoading from 'react-loading';

interface LoaderProps {
  type?: 'blank' | 'balls' | 'bars' | 'bubbles' | 'cubes' | 'cylon' | 'spin' | 'spinningBubbles' | 'spokes';
  color?: string;
  height?: number | string;
  width?: number | string;
}

const Loader: React.FC<LoaderProps> = ({
  type = 'bars',
  color = '#004e6a',
  height = 100,
  width = 100,
}) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <ReactLoading type={type} color={color} height={height} width={width} />
    </div>
  );
};

export default Loader;
